module.exports = "/assets/50870be0f1f588d85e2436da0349380b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SX.png
// module id = 1837
// module chunks = 0